module.exports = __webpack_public_path__ + "static/tips-kids-5457a512b4bf33b46c226c0a6e919a6b.jpg";